<template>
  <div class="navbar-background"></div>
  <nav class="navbar navbar-expand-lg color-white" aria-label="Главное меню">
    <div class="container">
      <RouterLink class="navbar-brand" to="/">
        <img :src="logoIMG" :alt="mainTitle" width="40" height="40" />
      </RouterLink>

      <div class="d-flex">
        <div class="lv-header-toolbar">
          <div class="dropdown">
            <a
              class="nav-link"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ auth.userInfo?.name }}<img src="@/assets/chevron-right.svg" />
            </a>
            <ul class="dropdown-menu dropdown-menu-end mt-3">
              <li>
                <RouterLink class="dropdown-item" :to="{ name: 'Profile' }">Пользователь</RouterLink>
              </li>
              <li>
                <a class="dropdown-item" href="/" @click="signOutHandler">Выйти</a>
              </li>
            </ul>
          </div>
          <RouterLink :to="{ name: 'NoticeView' }">
            <span class="icon-notice position-relative">
              <img
                src="@/assets/bell.svg"
                :class="{ 'icon-notice-unread': auth.notice_unread > 0 }"
              />
              <span class="notification-count" v-if="auth.notice_unread > 0">{{
                auth.notice_unread
              }}</span>
            </span>
          </RouterLink>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { RouterLink, useRouter } from "vue-router";
import { useAuthStore } from "@/stores/user-auth";

const router = useRouter();
const auth = useAuthStore();
const mainTitle = import.meta.env.VITE_BASE_NAME;
const logoIMG = "/img/icons/logo.svg";

const signOutHandler = () => {
  auth.userLogOut();
  router.push({ name: "login" });
};
</script>
<style>
.navbar-background {
  position: absolute;
  width: 100%;
  top: 0px;
  background-image: url(@/assets/back.svg);
  background-size: cover;
  border-radius: 0px 0px 32px 32px;
  height: 174px;
}
.color-white {
  color: #ffffff;
}
.lv-header-toolbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 40px;
}
.icon-notice {
  padding: 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  width: 48px;
  height: 48px;
  margin-right: 12px;
}
.navbar-toggler {
  border: none !important;
}
.lv-header-toolbar {
  gap: 12px;
}
.notification-count {
  position: absolute;
  top: -5px;
  right: -5px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: red;
  color: white;
  font-size: 12px;
}
</style>
